import type { ColumnDef } from "@tanstack/react-table";
import type { LobApprovalRow } from "../types/LobApproval";

export const lobApprovalColumns: ColumnDef<LobApprovalRow>[] = [
  { accessorKey: "name", header: "Line of Business" },
  { accessorKey: "requiredApprovals", header: "# Approvals" },
  {
    accessorKey: "submitterMayApprove",
    header: "Submitter Approves?",
    cell: ({ getValue }) => (getValue() ? "Yes" : "No"),
  },
  {
    accessorKey: "limitApprovalsToTeam",
    header: "Team Approval?",
    cell: ({ getValue }) => (getValue() ? "Yes" : "No"),
  },
  {
    id: "approvers",
    header: "Project Technical Approval",
    cell: ({ row }) =>
      row.original.approvers
        .map((a) => `${a.name}${a.requiredApprover ? "*" : ""}`)
        .join(", "),
  },
];
